import features from '../common/features';
import { has, isFunction } from 'lodash';

function defaultSummaryTitle(seatData) {
  let parts = [];
  if (has(seatData, 'screen.screen_desc')) {
    parts.push(seatData.screen.screen_desc);
  }
  if (has(seatData, 'zone')) {
    parts.push(`${seatData.zone}`);
  }
  if (has(seatData, 'seat_row')) {
    parts.push(`Row ${seatData.seat_row}`);
  }
  if (has(seatData, 'seat_num')) {
    parts.push(`Seat ${seatData.seat_num}`);
  }

  return parts.join(', ');
}

export default function summaryTitle(seatData, zones, customiserFn) {
  customiserFn =
    customiserFn || features.getOption('customSeatDescription', 'customiser');

  if (isFunction(customiserFn)) {
    return customiserFn.call(null, seatData, zones);
  } else {
    return defaultSummaryTitle(seatData);
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/summaryTitle.js